import React from "react";
import { Link } from "react-router-dom";
import { Edit } from "react-feather";
import { Button, Modal } from "antd";
import { useSelector, useDispatch } from "react-redux";
import Table from "../../../core/pagination/datatable";
//import RefreshIcon from "../../../core/common/tooltip-content/refresh";
//import CollapesIcon from "../../../core/common/tooltip-content/collapes";
import CommonFooter from "../../../core/common/footer/commonFooter";
import SettingsSideBar from "../settingssidebar";
import VatSituationFormModal from "./VatSituationFormModal";
import { fetchVatSituations, openModal, closeModal, openDeleteModal, closeDeleteModal, removeVatSituation, addVatSituation, editVatSituation } from "../../../core/redux/vatSituation.slice";
import StickyBar from "../../../core/common/StickyBar";
import { useTranslation } from "react-i18next";

const VatSituations = () => {
  const dispatch = useDispatch();
  const { vatSituations, showModal, showDeleteModal, loading } = useSelector((state) => state.vatSituation);
  const [selected, setSelected] = React.useState(null);
  const [toDelete, setToDelete] = React.useState(null);
  const [isEditMode, setIsEditMode] = React.useState(false);
  const { t } = useTranslation();

  React.useEffect(() => {
    if (!vatSituations.length) dispatch(fetchVatSituations());
  }, [dispatch, vatSituations]);

  const deleteVatSituation = () => dispatch(removeVatSituation(toDelete));
  const hideModal = () => dispatch(closeModal());

  const onFinish = (values) => {
    if (isEditMode) dispatch(editVatSituation({ id: selected.vatSituationId, vatSituation: values }));
    else dispatch(addVatSituation(values));
  };

  const columns = [
    { title: t("vatSituations.name"), dataIndex: "vatSituationName" },
    { title: t("vatSituations.description"), dataIndex: "vatSituationDescription" },
    {
      title: t("vatSituations.status"), dataIndex: "vatSituationIsActive", render: (isActive) => (
        <div>
          {isActive ? (
            <span className="d-inline-flex align-items-center p-1 pe-2 rounded-1 text-white bg-success fs-10"><i className="ti ti-point-filled me-1 fs-11"></i>Active</span>
          ) : (
            <span className="d-inline-flex align-items-center p-1 pe-2 rounded-1 text-white bg-danger fs-10"><i className="ti ti-point-filled me-1 fs-11"></i>Inactive</span>
          )}
        </div>
      ),
    },
    {
      title: "Actions",
      render: (_, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action">
            <Link
              className="me-2 p-2"
              to="#"
              onClick={() => { setIsEditMode(true); dispatch(openModal()); setSelected(record) }}
            >
              <Edit className="feather-edit" />
            </Link>
            <Link
              className="p-2 d-flex align-items-center border rounded"
              to="#"
              onClick={() => { setToDelete(record.vatSituationId); dispatch(openDeleteModal()) }}
            >
              <i data-feather="trash-2" className="feather-trash-2" />
            </Link>
          </div>
        </div>
      ),
    },
  ];

  return (
    <div>
      <div className="page-wrapper">
        <div className="content settings-content">

          <StickyBar
            title={t("vatSituations.title")}
            count={vatSituations.length}
            actions={
              <Button className="btn-customized-primary" >
                <Link to="#" onClick={() => { setIsEditMode(false); dispatch(openModal()) }}>
                  <i className="ti ti-circle-plus me-1" /> {t("vatSituations.add")}
                </Link>
              </Button>} />

          <div className="row">
            <div className="col-xl-12">
              <div className="settings-wrapper d-flex">
                <SettingsSideBar />
                <div className="flex-fill w-50">                  {showModal ? (
                  <VatSituationFormModal
                    loading={loading}
                    initialData={isEditMode ? selected : {}}
                    isEdit={isEditMode}
                    onSubmit={onFinish}
                    onCancel={hideModal}
                  />
                ) : (
                  <div className="card table-list-card">
                    <div className="card-header d-flex align-items-center justify-content-between">
                      <h4>{t("vatSituations.title")}</h4>

                    </div>
                    <div className="card-body">
                      <div className="table-responsive"><Table columns={columns} dataSource={vatSituations} /></div>
                    </div>
                  </div>
                )}

                </div>
              </div>
            </div>
          </div>
        </div>
        <CommonFooter />
      </div>

      {/* <VatSituationFormModal
        loading={loading}
        initialData={isEditMode ? selected : {}}
        isEdit={isEditMode}
        open={showModal}
        onSubmit={onFinish}
        onCancel={hideModal}
      /> */}

      <Modal onCancel={() => dispatch(closeDeleteModal())} open={showDeleteModal} footer="">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="page-wrapper-new p-0">
              <div className="content p-5 px-3 text-center">
                <span className="rounded-circle d-inline-flex p-2 bg-danger-transparent mb-2">
                  <i className="ti ti-trash fs-24 text-danger" />
                </span>
                <h4 className="fs-20 text-gray-9 fw-bold mb-2 mt-1">{t("vatSituations.deleteTitle")}</h4>
                <p className="text-gray-6 mb-0 fs-16">{t("vatSituations.deleteConfirm")}</p>
                <div className="modal-footer-btn mt-3 d-flex justify-content-center">
                  <Button size="large" className="btn me-2 btn-secondary" onClick={() => dispatch(closeDeleteModal())}>{t("common.cancel")}</Button>
                  <Button size="large" type="button" loading={loading} onClick={deleteVatSituation} className="btn btn-submit">{t("common.confirmDelete")}</Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default VatSituations;